import { GET, POST } from '../config'
import { IApiResponse } from '../../../interfaces/api-response.interface'
import {
  IApprovalsFetchPayload,
  IApprovalsFetchResponse,
  IDecide,
} from '../../../interfaces/approval.interface'

export interface IApprovalApi {
  decide: (payload: string, params?: IDecide) => Promise<IApiResponse>
  fetch: (
    payload?: string | null,
    params?: IApprovalsFetchPayload,
  ) => Promise<IApprovalsFetchResponse>
}

export default {
  decide: (payload: string, params?: IDecide): Promise<IApiResponse> => {
    return POST(`/api/v1/approvals/${payload}/`, { ...params }).then((res) => res.data)
  },

  fetch: (
    payload?: string | null,
    params?: IApprovalsFetchPayload,
  ): Promise<IApprovalsFetchResponse> => {
    return GET('/api/v1/approvals/', { params }).then((res) => res.data)
  },
}
